"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _get = _interopRequireDefault(require("lodash/get"));
var _TopNavBar = _interopRequireDefault(require("../TopNavBar"));
var _HeaderCountryLanguage = _interopRequireDefault(require("../../Organisms/HeaderCountryLanguage"));
var _HeaderLinksBar = _interopRequireDefault(require("../HeaderLinksBar/HeaderLinksBar"));
require("./Header.scss");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || (0, _typeof2.default)(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var HeaderSearchBar = (0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../HeaderSearchBar'));
  });
});
var Header = function Header(_ref) {
  var children = _ref.children,
    className = _ref.className,
    logo = _ref.logo,
    navItems = _ref.navItems,
    myAccountConfig = _ref.myAccountConfig,
    hamburgerClick = _ref.hamburgerClick,
    hamburgerValue = _ref.hamburgerValue,
    logoLink = _ref.logoLink,
    countryLanguageProps = _ref.countryLanguageProps;
  var _useState = (0, _react.useState)(false),
    isMobileSearchEnabled = _useState[0],
    showMobileSearchBar = _useState[1];
  var searchBarItems = (0, _get.default)(myAccountConfig, 'searchBarItems', {});
  var isEProc = (0, _get.default)(myAccountConfig, 'isEProc', false);
  var toggleMobileSearchBar = function toggleMobileSearchBar(visibility, scroll) {
    if (visibility === void 0) {
      visibility = true;
    }
    if (scroll === void 0) {
      scroll = true;
    }
    showMobileSearchBar(visibility && !isMobileSearchEnabled);
  };
  var onSearchRequest = searchBarItems.onSearchRequest,
    suggestions = searchBarItems.suggestions,
    iconSearch = searchBarItems.iconSearch,
    iconClear = searchBarItems.iconClear,
    searchPath = searchBarItems.searchPath,
    placeholderDesktop = searchBarItems.placeholderDesktop,
    placeholderMobile = searchBarItems.placeholderMobile,
    searchBarSubmit = searchBarItems.searchBarSubmit,
    defaultConfig = searchBarItems.defaultConfig,
    recentlySearched = searchBarItems.recentlySearched,
    labels = searchBarItems.labels,
    multipleIconUrl = searchBarItems.multipleIconUrl,
    searchBarInteraction = searchBarItems.searchBarInteraction;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("header", {
    id: "header",
    className: "page-header " + className,
    "data-locator": "header-container"
  }, _react.default.createElement("div", {
    className: "header-top-bar"
  }, _react.default.createElement("div", {
    className: "container"
  }, _react.default.createElement("div", {
    className: "header-top-bar-row"
  }, _react.default.createElement(_HeaderCountryLanguage.default, countryLanguageProps), _react.default.createElement(_HeaderLinksBar.default, countryLanguageProps)))), _react.default.createElement("div", {
    className: "top-bar container",
    "data-locator": "header-top-bar-container"
  }, _react.default.createElement(_TopNavBar.default, (0, _extends2.default)({
    logo: logo,
    navItems: navItems,
    myAccountConfig: myAccountConfig,
    hamburgerClick: hamburgerClick,
    hamburgerValue: hamburgerValue,
    logoLink: logoLink
  }, {
    toggleMobileSearchBar: toggleMobileSearchBar
  }, {
    children: children,
    isEProc: isEProc,
    id: "notesSearch",
    countryLanguageProps: countryLanguageProps
  }))), !!searchBarItems && !hamburgerValue && _react.default.createElement("div", {
    className: "cmp-search-autosuggest-mobile"
  }, _react.default.createElement(_react.Suspense, {
    fallback: _react.default.createElement("div", null)
  }, _react.default.createElement(HeaderSearchBar, (0, _extends2.default)({
    showBar: true,
    onSearchRequest: onSearchRequest,
    suggestions: suggestions,
    minSearchCharacters: "1",
    maxSuggestions: "10",
    iconSearch: iconSearch,
    iconClear: iconClear,
    searchPath: searchPath,
    placeholderDesktop: placeholderDesktop,
    placeholderMobile: placeholderMobile,
    defaultConfig: defaultConfig,
    searchBarSubmit: searchBarSubmit,
    labels: labels,
    recentlySearched: recentlySearched
  }, {
    toggleMobileSearchBar: toggleMobileSearchBar
  }, {
    multipleIconUrl: multipleIconUrl,
    isEProc: isEProc,
    searchBarInteraction: searchBarInteraction,
    id: "notesSearchMobile"
  }))))), _react.default.createElement("div", {
    className: "top-bar-nav__overlay"
  }));
};
Header.defaultProps = {
  className: '',
  navItems: [],
  logo: {},
  myAccountConfig: {},
  hamburgerClick: function hamburgerClick() {
    /* default hamburgerClick handler */
  },
  hamburgerValue: false,
  logoLink: '/'
};
var _default = Header;
exports.default = _default;
module.exports = exports["default"];